require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-about-us-credit-union-vs-bank.json") })
        }
      }, "path---es-about-us-credit-union-vs-bank");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-about-us-credit-union-vs-bank!./.cache/json/es-about-us-credit-union-vs-bank.json
// module id = 2017
// module chunks = 231608221292675